import React, { useEffect, useMemo } from "react";
import { Column } from "@ant-design/plots";
import { Empty, Spin } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useProjectState } from "../../../context/stateContext";
import organizationsStatisticsActions from "../../../redux/organizationsStatistics/actions";

const AdminOrganizationsStatisticsChart = () => {
  const dispatch = useDispatch();
  const { organizationsDailyStatistics, dailyLoading } = useSelector(
    (state) => state.organizationsStatisticsReducer
  );
  const { startDate, endDate } = useProjectState();

  const { getAllOrganizationsDailyByDatesStatistics } =
    organizationsStatisticsActions;

  useEffect(() => {
    const timer = setTimeout(() => {
      const formattedStartDate = startDate.replace(/\//g, "-");
      const formattedEndDate = endDate.replace(/\//g, "-");
      dispatch(
        getAllOrganizationsDailyByDatesStatistics(
          formattedStartDate,
          formattedEndDate
        )
      );
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const hasValues = organizationsDailyStatistics?.some(
    (item) => item.visits || item.orders || item.appendOrders || item.myPosPayments
  );

  const chartData = useMemo(() => {
    if (!organizationsDailyStatistics?.length) {
      return [];
    }

    const totalDays = organizationsDailyStatistics.length;
    const dateFormat = totalDays > 62 ? "MM.YY" : "DD.MM";

    return organizationsDailyStatistics.flatMap((item) => {
      const dateLabel = dayjs(item.date).format(dateFormat);
      return [
        {
          date: dateLabel,
          type: "Посещения",
          value: item.visits || 0,
        },
        {
          date: dateLabel,
          type: "Поръчки",
          value: item.orders || 0,
        },
        {
          date: dateLabel,
          type: "Допоръчвания",
          value: item.appendOrders || 0,
        },
        {
          date: dateLabel,
          type: "Плащания",
          value: item.myPosPayments || 0,
        },
      ];
    });
  }, [organizationsDailyStatistics]);

  const config = {
    data: chartData,
    isStack: true,
    xField: "date",
    yField: "value",
    seriesField: "type",
    legend: {
      position: "top",
    },
    xAxis: {
      label: {
        autoRotate: true,
        autoHide: true,
      },
    },
    tooltip: {
      formatter: (datum) => {
        return { name: datum.type, value: datum.value };
      },
    },
    color: ["#3066BE", "#F46036", "#F0A500", "#2E933C"],
  };

  return (
    <div className="admin-organizations-statistics-chart-wrapper">
      <div className="admin-organizations-statistics-chart-header">
        <h3>Дневна статистика</h3>
        <span>Посещения / Поръчки / Допоръчвания / Плащания</span>
      </div>
      <div className="admin-organizations-statistics-chart">
        {dailyLoading ? (
          <Spin />
        ) : hasValues ? (
          <Column {...config} />
        ) : (
          <Empty description="Няма данни за избрания период" />
        )}
      </div>
    </div>
  );
};

export default AdminOrganizationsStatisticsChart;
